export var PAGE_TYPE;

(function (PAGE_TYPE) {
  PAGE_TYPE["BUILD_PAGE"] = "Build Page";
})(PAGE_TYPE || (PAGE_TYPE = {}));

export var PreloadLinks = {};
export var ROUTES_ACCESSIBLE_WITHOUT_SESSION = ["/login", "/signup", "/_error", "/reset_password", "/forgot_password"];
export var ROUTES_TO_REDIRECT_WHEN_SESSION = ["/login", "/signup", "/"];
/*
 	NOT_AUTH_ROUTES = ["login", "signup", "error"],

 */

export var ROOT_PATH = "/";